import { useSelector } from "react-redux";

import { premiumHasAccessToAiAssistant } from "seneca-common/features/subscriptions/features/subscription/selectors";
import { subscriptionsFetchFinished } from "seneca-common/features/subscriptions/state";
import { isSignedIn } from "seneca-common/features/user/state";
import { useSelectorOnCondition } from "seneca-common/utils/hooks/selectors";

import useAppVariant from "features/common/hooks/useAppVariant";
import { isNativeAppiOSAndHidePremium } from "features/pwa/mobile/ios/utils/isNativeAppiOS";
import { chatBotEnabledForRegion } from "features/regions/selectors";

export default function useShowAskAmelia({
  gateFreeUsers = false
}: {
  gateFreeUsers?: boolean;
} = {}) {
  const appVariant = useAppVariant();
  const signedIn = useSelector(isSignedIn);
  const chatBotIsAvailableForRegion = useSelector(chatBotEnabledForRegion);
  const subscriptionsFetched = useSelector(subscriptionsFetchFinished);
  const hasAiAssistant = !!useSelectorOnCondition(
    subscriptionsFetched,
    premiumHasAccessToAiAssistant
  );

  const canShowInRegion = signedIn && chatBotIsAvailableForRegion;
  const showToSubscribersOnly = canShowInRegion && hasAiAssistant;

  const valuesByVariant = {
    seneca:
      isNativeAppiOSAndHidePremium() || gateFreeUsers
        ? showToSubscribersOnly
        : canShowInRegion,
    senecaPrimary: showToSubscribersOnly,
    plurall: false,
    goStudentLearning: showToSubscribersOnly
  };

  return valuesByVariant[appVariant];
}
